<template>
    <div class="layout" :style="layoutStyles">
        <RockHeader />
        <router-view />
        <SuccessPopup v-show="showSuccessPopup" />
    </div>
</template>
<script>
import RockHeader from '@/components/RockHeader';
import SuccessPopup from '@/components/SuccessPopup';
import EventBus from '@/shared/VueEvent';
import WALLPAPERS, {
    getWallpaperFromStorage,
    setWallpaperInStorage,
    getWallpaperFromId
} from '@/constants/wallpapers';

export default {
    components: {
        RockHeader,
        SuccessPopup
    },
    data() {
        return {
            showSuccessPopup: false,
            backgroundImage: getWallpaperFromStorage
        };
    },
    computed: {
        layoutStyles() {
            return {
                backgroundImage: `url(${this.backgroundImage.path})`
            };
        }
    },
    created() {
        this.getSettings();
    },
    mounted() {
        const self = this;
        EventBus.listen('toggleSuccessPopup', (toggle) => {
            if (toggle) {
                self.showSuccessPopup = true;
                return;
            }
            self.showSuccessPopup = false;
        });

        EventBus.listen('changeBackgroundImage', (wallpaper) => {
            self.backgroundImage = wallpaper;
        });
    },
    methods: {
        getSettings() {
            const self = this;
            self.$http.get('/settings').then(({ data }) => {
                const wallpaper = getWallpaperFromId(
                    data.wallpaper.toUpperCase()
                );
                EventBus.fire('getBackgroundImageSuccessful', wallpaper);
                self.backgroundImage = wallpaper;
            });
        }
    }
};
</script>

<style lang="scss">
@import './sass/base.scss';
</style>

<style lang="scss" scoped>
.layout {
    min-height: 100vh;
    background-size: cover;
    background-attachment: fixed;
}
</style>
